import React from "react";
import { Link } from "react-router-dom";

function Breadcrumbs(props) {
  return (
    <ol className="breadcrumb">
      <li>
        <Link to="/">Home</Link>
      </li>
      {props.breadcrumbs.map((p, i) => (
        <li key={p.name} className={p.active ? "active" : ""}>
          {p.active ? p.name : <Link to={p.url}>{p.name}</Link>}
        </li>
      ))}
    </ol>
  );
}

export default Breadcrumbs;
